export default __webpack_public_path__ + "static/media/sanity.923a554c.png";